module.exports = __webpack_public_path__ + "static/media/offlineIMG.c16f3218.jpg";